import React, { useCallback } from 'react';
import { Box, Text, Button, Layer } from 'grommet';
import { Formik } from 'formik';
import * as Yup from 'yup';
import PropTypes from 'prop-types';
import FormField from 'granite-admin/core/components/FormField';
import Divider from 'granite-admin/core/components/Divider';
import OptionsField from '../../OptionsField';
import { FileList } from '../../UploadFile/components/utils';
const DocType = ({
  handleLayerClose,
  eventEmitter,
  setShow,
  uploadFile,
  fileData,
  setFileData,
  fields
}) => {
  const shape = {};
  shape[fields[0]] = Yup.string().required('Type is a required field').nullable();
  shape[fields[1]] = Yup.string().required('Sub Type is a required field').nullable();
  const validationSchema = Yup.object().shape({
    ...shape
  });
  const layer = {};
  const removeFile = useCallback(async (files, selectedFile, setFileData) => {
    let fileArr = [...files];
    fileArr = fileArr.filter(i => i !== selectedFile);
    setFileData({
      ...fileData,
      files: fileArr
    });
  }, [fileData]);

  // useEffect(() => {
  //   getContentTypes(eventEmitter);
  // }, [eventEmitter]);

  let initialValues = {
    // entityName: layer?.entityName || '',
    docsData: false
  };
  initialValues[fields[0]] = '';
  initialValues[fields[1]] = '';
  const onSubmit = async (values, {
    setSubmitting,
    setErrors
  }) => {
    setErrors({});
    setSubmitting(true);
    try {
      if (!fileData.files || fileData?.files?.length <= 0) {
        setErrors({
          docsData: 'Documents is a required field'
        });
      } else {
        const payload = {
          ...values,
          ...fileData,
          document_type: values[fields[0]],
          document_sub_type: values[fields[1]]
        };
        await uploadFile(eventEmitter, payload);
        setFileData({
          files: []
        });
        handleLayerClose();
      }
    } catch (e) {
      if (e.errors) setErrors(e.errors);
    }
    setSubmitting(false);
  };
  return /*#__PURE__*/React.createElement(Layer, {
    onClickOutside: handleLayerClose,
    onEsc: handleLayerClose
  }, /*#__PURE__*/React.createElement(Box, {
    flex: true,
    width: "large"
  }, /*#__PURE__*/React.createElement(Formik, {
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: onSubmit,
    validateOnMount: true
  }, ({
    values,
    handleSubmit,
    isSubmitting,
    setFieldValue,
    setFieldTouched,
    touched,
    errors
  }) => {
    return /*#__PURE__*/React.createElement("form", {
      onSubmit: handleSubmit
    }, /*#__PURE__*/React.createElement(Box, {
      align: "center",
      justify: "between",
      direction: "row",
      pad: "medium"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "large",
      weight: "bold"
    }, "Upload Documents")), /*#__PURE__*/React.createElement(Divider, {
      color: "brand"
    }), /*#__PURE__*/React.createElement(Box, {
      flex: true,
      pad: "medium",
      gap: {
        column: 'medium'
      }
    }, /*#__PURE__*/React.createElement(OptionsField, {
      label: "Type*",
      name: fields[0],
      valueKey: {
        key: 'name',
        reduce: true
      },
      value: values[fields[0]],
      onChange: async val => {
        setFieldValue(fields[1], '');
      },
      error: touched[fields[0]] && errors[fields[0]],
      onBlur: e => !touched[fields[0]] && setFieldTouched(fields[0], true)
    }), /*#__PURE__*/React.createElement(OptionsField, {
      label: "Sub Type*",
      name: fields[1],
      valueKey: {
        key: 'name',
        reduce: true
      },
      value: values[fields[1]],
      error: touched[fields[1]] && errors[fields[1]],
      onBlur: e => !touched[fields[1]] && setFieldTouched(fields[1], true)
    })), fileData?.files?.length === 0 && /*#__PURE__*/React.createElement(FormField, {
      name: "docsData",
      noBorder: true,
      error: touched.docsData && errors.docsData,
      margin: {
        vertical: 'small'
      },
      pad: {
        left: 'small',
        right: 'medium'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      size: "small"
      // width="medium"
      ,
      primary: true,
      label: "Upload*",
      onClick: () => {
        setShow(true);
      },
      onBlur: () => {
        if (Object.keys(fileData).length > 0) {
          setFieldValue('docsData', true);
        }
      },
      style: {
        maxWidth: '90px'
      }
    })), fileData?.files?.length ? /*#__PURE__*/React.createElement(FileList, {
      files: fileData?.files,
      removeFile: removeFile,
      setFieldValue: setFileData
    }) : null, /*#__PURE__*/React.createElement(Box, {
      direction: "row",
      as: "footer"
    }, /*#__PURE__*/React.createElement(Button, {
      label: "Cancel",
      color: "light-4",
      style: {
        borderRadius: '0px',
        backgroundColor: '#DADADA',
        width: '50%'
      },
      onClick: handleLayerClose
    }), /*#__PURE__*/React.createElement(Button, {
      type: "submit",
      label: layer?.pk ? 'Update Documents' : 'Save Documents',
      primary: true,
      style: {
        borderRadius: '0px',
        width: '50%'
      },
      disabled: isSubmitting
    })));
  })));
};
DocType.propTypes = {
  uploadFile: PropTypes.any,
  handleLayerClose: PropTypes.func,
  eventEmitter: PropTypes.func,
  fileData: PropTypes.object,
  setFileData: PropTypes.object,
  setShow: PropTypes.func,
  fields: PropTypes.array
};
export default DocType;